module.exports = __webpack_public_path__ + "img/Pisces.105661cc.png";